'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import SelectedOptionButton from './selected-option-button';
import translate from '../_utils/tools/translate';

// -----------------------------------------------------------
//  SelectedOptions
// -----------------------------------------------------------
const SelectedOptions = props => {
  const handleClearClicked = (name, option) => {
    props.onClearClick(name, option);
  };

  const handleClearDelivery = name => {
    const { selectedDeliveryOptions, deliveryOptions, onDeliveryOptionClicked } = props;
    const [selectedOption] = deliveryOptions.filter(
      option => option.title === name
    );
    onDeliveryOptionClicked(selectedDeliveryOptions.filter(
       option => selectedOption.key !== option
    ))
  };

  const getDeliveryOptionNames = () => {
    let delivery_option_names = [];
    props.deliveryOptions.forEach(delivery => {
      if (props.selectedDeliveryOptions.includes(delivery.key)) {
        delivery_option_names.push(delivery.title);
      }
    });
    return delivery_option_names;
  };
  const { onClearAllFilters } = props;
  return (
    <div className="mt-2">
      <div className="row ml-3 selected-filter-title d-flex flex-wrap justify-content-between mr-3">
        <div>Selected Filters</div>
        <div>
          <button onClick={onClearAllFilters} className="clear-filter-menu">
            {translate('Clear all')}
          </button>
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-start m-2 selected-options">
        {Object.entries(props.selectedFilters).map(
          ([filter, arrayOfValues]) => {
            return arrayOfValues.map(value => {
              if (props.availableFilters.map(value => value.key.toLowerCase()).includes(filter.toLowerCase())) {
                return (
                  <SelectedOptionButton
                    title={value}
                    onClearClick={handleClearClicked}
                    key={value}
                    filterName={filter}
                  />
                );
              }
            });
          }
        )}
        {getDeliveryOptionNames().map(value => {
          return (
            <SelectedOptionButton
              title={value}
              onClearClick={handleClearDelivery}
              key={value}
              filterName={value}
            />
          );
        })}
      </div>
    </div>
  );
};

SelectedOptions.propTypes = {
  selectedDeliveryOptions: PropTypes.array,
  selectedFilters: PropTypes.object,
  availableFilters: PropTypes.array,
  onClearClick: PropTypes.func,
  showSelectedOptions: PropTypes.bool,
  deliveryOptions: PropTypes.array,
  onDeliveryOptionClicked: PropTypes.func,
};

export default SelectedOptions;
